<app-modal
  [isActive]="isActive"
  [showClose]="false"
  [closeOnEsc]="false"
  [showCloseFooter]="showCloseFooterModal"
  [isLarge]="true"
  (modalState)="closeModal.emit($event)"
>
  <div modal-content>
    <div *ngIf="logInLogState?.isError">
      <div class="log-in-log-alert-container">
        <app-alert type="error">
          <span class="weight-medium" title>
            {{ 'itinerary-info.log-in-log.error-title' | translate }}
          </span>
          <span description>
            {{ 'itinerary-info.log-in-log.error-description' | translate }}.
          </span>
        </app-alert>
      </div>

      <div *ngIf="logInLogState?.error" class="log-in-log-text-container">
        <p>
          {{ logInLogState?.error }}
        </p>
      </div>

      <div class="log-in-log-button-container">
        <app-input-submit
          inputText="{{ 'shared.try-again' | translate }}"
          type="submit"
          (clickButton)="saveLogInLog()"
        ></app-input-submit>
      </div>
    </div>

    <div *ngIf="logInLogState?.logInLogRegistered">
      <div class="log-in-log-text-container">
        <p>{{ 'itinerary-info.log-in-log.registered' | translate }}.</p>
      </div>
    </div>
  </div>
</app-modal>
